import React from "react";
import { Box, Typography, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThreeDots } from "react-loader-spinner";
import PropTypes from "prop-types";
import { useAiLoadingMessages } from "../../hooks/useAiLoadingMessages";

const useStyles = makeStyles(() => ({
  container: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  },
  message: {
    fontSize: "12px",
    color: "#666",
    fontStyle: "italic",
    lineHeight: 1.2,
    animation: "$fadeIn 0.3s ease-in-out",
    whiteSpace: "nowrap",
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
}));

/**
 * Componente que exibe um indicador de loading com mensagens rotativas
 * @param {boolean} isLoading - Se está carregando
 * @param {string} context - Contexto das mensagens ('documentation' ou 'speech')
 * @param {number} interval - Intervalo entre mensagens (opcional)
 * @param {string} color - Cor do loader (opcional)
 */
const AiLoadingIndicator = ({ isLoading, context, interval, color }) => {
  const classes = useStyles();
  const currentMessage = useAiLoadingMessages(isLoading, context, interval);

  if (!isLoading) {
    return null;
  }

  return (
    <Box className={classes.container}>
      <ThreeDots
        height="20"
        width="30"
        radius="3"
        color={color}
        ariaLabel="loading"
        visible={true}
      />
      <Fade in={!!currentMessage} timeout={300}>
        <Typography className={classes.message} key={currentMessage}>
          {currentMessage}
        </Typography>
      </Fade>
    </Box>
  );
};

AiLoadingIndicator.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  context: PropTypes.oneOf(["documentation", "speech"]),
  interval: PropTypes.number,
  color: PropTypes.string,
};

AiLoadingIndicator.defaultProps = {
  context: "documentation",
  interval: 2500,
  color: "#00acc1",
};

export default AiLoadingIndicator;
